import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p7 from '../assets/images/ebook1.gif';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                   <b>Get your ebooks with just a click...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p7} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://wattpad.com/" className="btn btn-xl btn-light mr-4">
         Wattpad
        </a>
        <a href="http://bookboon.com/" className="btn btn-xl btn-dark">
        Bookboon
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.pdfdrive.com/" className="btn btn-xl btn-light mr-4">
         Pdf Drive
        </a>
        <a href="http://gutenberg.org/" className="btn btn-xl btn-dark">
         Gutenberg
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.goodreads.com/genres/ebooks" className="btn btn-xl btn-light mr-4">
          Good Reads
        </a>
        <a href="http://openlibrary.org/" className="btn btn-xl btn-dark">
          Open Library
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">Read and Download all your e-books on the Web Smartly..<i className="fa fa-book fa-spin"></i></h2>
        </div>
        
      </div>
    </section>









     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.getfreeebooks.com/" className="btn btn-xl btn-light mr-4">
         Free e-books
        </a>
        <a href="http://archive.org/" className="btn btn-xl btn-dark">
       Internet Archive
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.amazon.com/b/?_encoding=UTF8&camp=1789&creative=9325&linkCode=ur2&node=2245146011&tag=freeblog022-20&linkId=BNRPUFVEMRQP2NRR" className="btn btn-xl btn-light mr-4">
         Amazon Free E-Books
        </a>
        <a href="https://books.google.com/" className="btn btn-xl btn-dark">
         Google books
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://manybooks.net/" className="btn btn-xl btn-light mr-4">
        Many Books
        </a>
        <a href="https://paajoelibrary.blogspot.com" className="btn btn-xl btn-dark">
         Paajoe Library
        </a>
      </div>
    </section>



<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>

          <h2 className="mb-5">Ebooks are fun to read anywhere..<i className="fa fa-book fa-spin"></i></h2>
        </div>
        
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://libgen.rs/" className="btn btn-xl btn-light mr-4">
        Library Genesis
        </a>
        <a href="http://www.freebookspot.es/" className="btn btn-xl btn-dark">
         Free Book Spot
        </a>
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.free-ebooks.net/" className="btn btn-xl btn-light mr-4">
        Free Ebooks.net
        </a>
        <a href="https://librivox.org/" className="btn btn-xl btn-dark">
         Librivox
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.getfreeebooks.com/" className="btn btn-xl btn-light mr-4">
        GetFree ebooks
        </a>
        <a href="https://freecomputerbooks.com/" className="btn btn-xl btn-dark">
         Free Computer Books
        </a>
      </div>
    </section>





<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">When one teaches, Two learn..<i className="fa fa-book fa-spin"></i></h2>
        </div>
        
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.baen.com/catalog/category/view/s/free-library/id/2012" className="btn btn-xl btn-light mr-4">
        Baen Books
        </a>
        <a href="https://knowfree.tradepub.com/" className="btn btn-xl btn-dark">
        Trade Pub
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.openculture.com/free_ebooks" className="btn btn-xl btn-light mr-4">
       Open Culture
        </a>
        <a href="https://www.onlineprogrammingbooks.com/" className="btn btn-xl btn-dark">
         Online Programming Books
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.bookyards.com/en/welcome" className="btn btn-xl btn-light mr-4">
        Book Yards
        </a>
        <a href="http://www.feedbooks.com/publicdomain" className="btn btn-xl btn-dark">
         Feed Books
        </a>
      </div>
    </section>





<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">Read and Believe it..<i className="fa fa-book fa-spin"></i></h2>
        </div>
        
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://digital.library.upenn.edu/books/" className="btn btn-xl btn-light mr-4">
       Digital Library
        </a>
        <a href="http://www.ebooklobby.com/" className="btn btn-xl btn-dark">
         Ebook Lobby
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.c3f.com/alivfree.html" className="btn btn-xl btn-light mr-4">
       Alive aND FREE
        </a>
        <a href="https://avxhm.se/ebooks" className="btn btn-xl btn-dark">
        Avax Home
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.pdfbooksworld.com/" className="btn btn-xl btn-light mr-4">
        PDF Books World
        </a>
        <a href="http://en.childrenslibrary.org/" className="btn btn-xl btn-dark">
         International Children's Digital Library
        </a>
      </div>
    </section>








<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://en.wikibooks.org/wiki/Main_Page" className="btn btn-xl btn-light mr-4">
        WIKI Books
        </a>
        <a href="http://e-library.net/" className="btn btn-xl btn-dark">
         E-Library
        </a>
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.planetebook.com/" className="btn btn-xl btn-light mr-4">
        Planet Ebook
        </a>
        <a href="https://leanpub.com/" className="btn btn-xl btn-dark">
         Lean Pub
        </a>
      </div>
    </section>





    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.oxfordowl.co.uk/for-home/find-a-book/library-page" className="btn btn-xl btn-light mr-4">
        Oxford owl
        </a>
        <a href="https://creator.lightreader.com/login" className="btn btn-xl btn-light mr-4">
        Light Reader
        </a>
      </div>
    </section>














    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
